import React from 'react';
import { Box } from '@mui/material';
import { __t } from '../../i18n/t';

interface IImageInformations {
    position?: number;
    /** Tem que acompanhar o `maxBytes` da rota que recebe o arquivo, senão o aviso mente. */
    maxSizeMb?: number;
}

const ImageInformations: React.FC<IImageInformations> = ({ position, maxSizeMb = 3 }) => {
    return (
        <>
            <Box
                component="p"
                sx={{
                    position: 'relative',
                    top: `${position ? position : -15}px`,
                    fontSize: 12,
                    opacity: 0.75,
                    fontFamily: 'Helvetica',
                }}
            >
                <Box component="span" sx={{ color: 'red' }}>* </Box>
                {__t('A imagem deve ter o tamanho máximo de %{size}MB. Os formatos aceitos são .jpeg e .png.', { size: maxSizeMb })}
            </Box>
        </>
    );
}

export default ImageInformations;
